import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { usePermissions } from '../context/PermissionsContext';
import { isPrivilegedRole, normalizeModulePath, rolExcluido } from '../config/comingSoonRoutes';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { hasModuleAccess, loaded } = usePermissions();
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!loaded) {
    return null;
  }

  if (rolExcluido(user.role, location.pathname)) {
    return <Navigate to="/inicio" replace />;
  }

  // Admin y TI pueden acceder a todo
  if (isPrivilegedRole(user.role)) {
    return children;
  }

  const path = normalizeModulePath(location.pathname);

  // Rutas que siempre están permitidas para cualquier usuario autenticado
  const alwaysAllowed = ['/'];
  if (alwaysAllowed.includes(path)) {
    return children;
  }

  if (!hasModuleAccess(user, path)) {
    return <Navigate to="/inicio" replace />;
  }

  return children;
};

export default PrivateRoute;
